import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserCards } from "../../../../state/selectors/userCards";
import styled from "styled-components";
import PlusIcon from "../../../../resources/icons/plus_white.png";
import RemoveIcon from "../../../../resources/icons/minus-circle-red.png";
import { withTranslation } from "react-i18next";
import userCardService from "../../../../services/userCardService";
import log from "../../../../services/logger/log";
import Loader from "../../../../components/loader/loader";

const UserTableViewStyled = styled.table`
  border-collapse: collapse;
  border: 0px;
  width: 100%;
  border-spacing: 0;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
`;

const UserTableBodyStyled = styled.tbody`
  tr {
    height: 30px;
    text-align: center;
    color: black;

    &:nth-child(even) {
      background: #e5e5e5;
    }

    &:nth-child(odd) {
      background: #f8f8f8;
    }
  }
`;

const UserTableHeaderStyled = styled.thead`
  height: 40px;
  background-color: #e5e5e5;
  position: sticky;
  position: -webkit-sticky;
  top: 0;

  th {
    text-align: center;
    color: black;
  }
`;

const UserTableRowStyled = styled.tr``;

const UserTabSelectorContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: end;
  gap: 1.25rem;
  padding: 10px 10px;
`;

const AddItemButtonStyled = styled.button`
  right: 20px;
  width: 50px;
  height: 30px;
  display: block;
  border: 0;
  cursor: pointer;
  border-radius: 3px;
  background: #1976d2 no-repeat;
  background-position: center;
  background-image: url(${PlusIcon});
  background-size: 30px;

  &:hover {
    border: 1px solid #aaa;
  }

  &:disabled {
    background: #999 no-repeat;
    background-position: center;
    background-image: url(${PlusIcon});
    background-size: 30px;
    pointer-events: none;
    cursor: default;
  }
`;

const RemoveItemButtonStyled = styled.button`
  width: 25px;
  height: 25px;
  display: block;
  margin: auto;
  border: 1px solid #ddd;
  cursor: pointer;
  border-radius: 3px;
  background: #f8f8f8;
  background-image: url(${RemoveIcon});
  background-position: center;
  background-size: 25px;

  &:hover {
    border: 1px solid #aaa;
  }

  &:disabled {
    background: #999;
    pointer-events: none;
    cursor: default;
  }
`;

const UserTable = ({ userCards, userIds = [], onRemoveItem, t }) => {
  const items = userCards.filter(
    (item) => userIds.findIndex((x) => x === item.userCardId) >= 0
  );
  return (
    <UserTableViewStyled>
      <UserTableHeader t={t} />
      <UserTableBodyStyled>
        {items.map((item) => {
          return (
            <UserTableRow
              user={item}
              onRemoveItem={onRemoveItem}
            ></UserTableRow>
          );
        })}
      </UserTableBodyStyled>
    </UserTableViewStyled>
  );
};

const UserTableHeader = ({ t }) => {
  return (
    <UserTableHeaderStyled>
      <tr>
        <th>{t("Cards.cardNumber")}</th>
        <th>{t("Cards.userName")}</th>
        <th></th>
      </tr>
    </UserTableHeaderStyled>
  );
};
const UserTableRow = ({ user, onRemoveItem }) => {
  return (
    <UserTableRowStyled>
      <td>{user.cardNumberInternal}</td>
      <td>{user.userName}</td>
      <td>
        <RemoveItemButtonStyled
          onClick={(e) => {
            e.preventDefault();
            onRemoveItem(user.userCardId);
          }}
        />
      </td>
    </UserTableRowStyled>
  );
};

const UserCardsTabView = ({
  existingCards = [],
  onAddUser,
  onRemoveUser,
  t,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState();
  const [userCards, setUserCards] = useState([]);
  const [userListItems, setUserListItems] = useState([]);

  useEffect(() => {
    userCardService
      .getAllCardsAsync()
      .then((items) => {
        setUserCards(items);
      })
      .catch((err) => {
        log.error(
          `An error occurred during the loading of user cards list. ${err}`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const usersList =
      userCards?.filter(
        (item) => existingCards.findIndex((x) => x === item.userCardId) < 0
      ) || [];
    
    setUserListItems(usersList);
    setSelectedUser(usersList?.length > 0 ? usersList[0].userCardId : null);
  }, [userCards, existingCards]);

  return (
    <div style={{ width: "675px" }}>
      <UserTabSelectorContainerStyled>
        <select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          {userListItems.map((item, index) => (
            <option
              key={`${index}_${item.cardNumberInternal}`}
              value={item.userCardId}
            >
              {`${item.cardNumberInternal} ${item.userName}`}
            </option>
          ))}
        </select>
        {loading ? (
          <Loader></Loader>
        ) : (
          <AddItemButtonStyled
            disabled={!selectedUser}
            onClick={(e) => {
              e.preventDefault();
              onAddUser(selectedUser);
            }}
          ></AddItemButtonStyled>
        )}
      </UserTabSelectorContainerStyled>

      {existingCards?.length > 0 && (
        <UserTable
          userCards={userCards}
          userIds={existingCards}
          onRemoveItem={onRemoveUser}
          t={t}
        />
      )}
    </div>
  );
};

export default withTranslation("translations")(UserCardsTabView);
